// content/globals.js

export const businessInfo = {
  name: 'Mayes Auto Detailing',
  tagline: "When clean isn't enough... Get MAD!",
  phone: '(423) 497-0881',
  email: 'info@mayesautodetailing.com',
  address: {
    street: '3921 Weldon Dr',
    city: 'Chattanooga',
    state: 'TN',
    zip: '37412',
  },
  logo: {
    publicId: {
      badgeFormat: 'mad-web-app/logo-images/mad-badge',
      logoOnly: 'mad-web-app/logo-images/favicon',
    },
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/v1741893335/mad-web-app/logo-images/mad-badge.png',
    alt: 'Mayes Auto Detailing Logo',
  },
  website: 'https://getmadpro.com',

  socials: [
    {
      name: 'facebook',
      url: 'https://www.facebook.com/MayesAutoDetailing',
      iconName: 'FaFacebook',
    },
    {
      name: 'instagram',
      url: 'https://instagram.com/MayesAutoDetailing',
      iconName: 'FaInstagram',
    },
    {
      name: 'linkedin',
      url: 'https://linkedin.com/company/mayesautodetailing',
      iconName: 'FaLinkedin',
    },
    {
      name: 'google',
      url: 'https://g.page/r/CYNoW5flBCQqEAE',
      iconName: 'FaGoogle',
    },
    {
      name: 'x',
      label: 'X (formerly Twitter)',
      url: 'https://twitter.com/MayesAutoDetail',
      iconName: 'FaXTwitter',
    },
    {
      name: 'tiktok',
      url: 'https://www.tiktok.com/@mayesautodetailing',
      iconName: 'FaTiktok',
    },
  ],

  hoursOfOperation: {
    monday: '8:30 AM – 6:00 PM',
    tuesday: '8:30 AM – 6:00 PM',
    wednesday: '8:30 AM – 6:00 PM',
    thursday: '8:30 AM – 6:00 PM',
    friday: '8:30 AM – 6:00 PM',
    saturday: '8:30 AM – 1:00 PM',
    sunday: 'Closed',
  },

  brandColors: {
    primary: '#ce2034', // primary brand color for CTAs, links, key UI elements
    secondary: '#0a1f42', // supporting tone for hover states and subheadings
    accent: '#F2B705', // accent hue for subtle highlights and badges
    neutral: '#F7F7F7', // background canvas for cards, panels, sections
    text: '#1A1A1A', // default copy color for maximum readability
  },

  businessCategory: 'Auto Detailing Service',
  paymentMethods: ['Visa', 'Mastercard', 'Amex', 'Discover', 'Cash', 'Venmo'],
  bookingUrl: 'https://getmadpro.com/book',
  privacyPolicyUrl: '/policies/privacy-policy',
  termsOfServiceUrl: '/policies/terms-and-conditions',
  refundPolicyUrl: '/policies/refund-policy',
};
